import { render } from "./Form.vue?vue&type=template&id=5de9bdde&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=5de9bdde&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5de9bdde"

export default script